export default "__VITE_PUBLIC_ASSET__8e16ec1c__"